import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import Footer from '../components/footer'
import './about-us.css'

const AboutUs = (props) => {
  return (
    <div className="about-us-container1">
      <Helmet>
        <title>AboutUs - R.A.C.E. Consulting</title>
        <meta
          name="description"
          content="Empowering high school students to confidently own their future through college admissions, scholarships &amp; career paths with less stress, stronger family ties."
        />
        <meta property="og:title" content="AboutUs - R.A.C.E. Consulting" />
        <meta
          property="og:description"
          content="Independent consultant helping teens go from high school to their future, making college admissions, scholarships &amp; career choices clear and stress-free."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/4dd8a2a4-fe48-48cd-8cb1-f0a7df20a883/ea77a8a8-ecc2-4dba-b7bc-a9a53426c250?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://notus-pro-wndqzl.teleporthq.site/about-us"
        />
      </Helmet>
      <div className="about-us-container2">
        <header
          data-thq="thq-navbar"
          className="about-us-thq-navbar-interactive-elm"
        >
          <Link to="/" className="about-us-navlink10">
            <img
              alt="image"
              src="https://raceconsulting24.com/logo.png"
              className="about-us-image1"
            />
          </Link>
          <Link to="/" className="about-us-navlink11">
            <h1 className="about-us-text10">R.A.C.E. Consulting, LLC</h1>
          </Link>
          <div
            data-thq="thq-navbar-nav"
            className="about-us-thq-desktop-menu-elm"
          >
            <nav className="about-us-thq-links-elm1">
              <Link to="/" className="about-us-navlink12">
                Home
              </Link>
              <Link to="/services" className="about-us-navlink13">
                Services
              </Link>
              <Link to="/about-us" className="about-us-navlink14">
                About Us
              </Link>
              <Link to="/contact-us" className="about-us-navlink15">
                Contact Us
              </Link>
            </nav>
            <div className="about-us-container3">
              <a
                href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer noopener"
                className="about-us-link1"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="about-us-icon10"
                >
                  <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                target="_blank"
                rel="noreferrer noopener"
                className="about-us-link2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="about-us-icon12"
                >
                  <g fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path
                      d="M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path d="M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5Z"></path>
                    <path
                      d="m17.5 6.51l.01-.011"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
                target="_blank"
                rel="noreferrer noopener"
                className="about-us-link3"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="about-us-icon17"
                >
                  <path
                    d="M1 2.838A1.84 1.84 0 0 1 2.838 1H21.16A1.837 1.837 0 0 1 23 2.838V21.16A1.84 1.84 0 0 1 21.161 23H2.838A1.84 1.84 0 0 1 1 21.161zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634c3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8c-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708zm-5.5 10.403h3.208V9.25H4.208zM7.875 5.812a2.063 2.063 0 1 1-4.125 0a2.063 2.063 0 0 1 4.125 0"
                    fill="currentColor"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  ></path>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@MelissaDecker-n6k"
                target="_blank"
                rel="noreferrer noopener"
                className="about-us-link4"
              >
                <svg
                  height="32"
                  width="32"
                  viewBox="0 0 32 32"
                  className="about-us-icon20"
                >
                  <path
                    fill="currentColor"
                    d="M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36 36 0 0 0 2 16a36 36 0 0 0 .59 6.74a3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36 36 0 0 0 30 16a36 36 0 0 0-.59-6.74M13.2 20.2v-8.4l7.27 4.2Z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
          <div
            data-thq="thq-burger-menu"
            className="about-us-thq-burger-menu-elm"
          >
            <svg viewBox="0 0 1024 1024" className="about-us-icon19">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div
            data-thq="thq-mobile-menu"
            className="about-us-thq-mobile-menu-elm"
          >
            <div className="about-us-thq-nav-elm">
              <div className="about-us-thq-top-elm">
                <span className="about-us-text11">R.A.C.E. Consulting</span>
                <div
                  data-thq="thq-close-menu"
                  className="about-us-thq-close-menu-elm"
                >
                  <svg viewBox="0 0 1024 1024" className="about-us-icon21">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav className="about-us-thq-links-elm2">
                <Link to="/" className="about-us-navlink16">
                  Home
                </Link>
                <Link to="/services" className="about-us-navlink17">
                  Services
                </Link>
                <Link to="/about-us" className="about-us-navlink18">
                  About Us
                </Link>
                <Link to="/contact-us" className="about-us-navlink19">
                  Contact Us
                </Link>
              </nav>
              <div>
                <a
                  href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    viewBox="0 0 602.2582857142856 1024"
                    className="about-us-icon23"
                  >
                    <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="about-us-icon25"
                  >
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="about-us-icon27"
                  >
                    <path
                      d="M9.429 8.969h3.714v1.85c.535-1.064 1.907-2.02 3.968-2.02c3.951 0 4.889 2.118 4.889 6.004V22h-4v-6.312c0-2.213-.535-3.461-1.897-3.461c-1.889 0-2.674 1.345-2.674 3.46V22h-4zM2.57 21.83h4V8.799h-4zM7.143 4.55a2.53 2.53 0 0 1-.753 1.802a2.57 2.57 0 0 1-1.82.748a2.6 2.6 0 0 1-1.818-.747A2.55 2.55 0 0 1 2 4.55c0-.677.27-1.325.753-1.803A2.58 2.58 0 0 1 4.571 2c.682 0 1.336.269 1.819.747s.753 1.126.753 1.803"
                      fill="currentColor"
                      clipRule="evenodd"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@MelissaDecker-n6k"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    height="21"
                    width="21"
                    viewBox="4 -2 42 42"
                    className="about-us-icon31"
                  >
                    <g fill="none" stroke="currentColor" strokeLinejoin="round">
                      <path
                        strokeWidth="4"
                        d="M11.064 10.414Q19.378 10 23.998 10t12.939.415a6 6 0 0 1 5.68 5.492q.381 4.55.381 8.017q0 3.508-.39 8.128a6 6 0 0 1-5.587 5.483Q29.91 38 23.998 38q-5.91 0-13.018-.465a6 6 0 0 1-5.587-5.48q-.395-4.655-.395-8.131q0-3.435.385-8.02a6 6 0 0 1 5.68-5.49Z"
                      ></path>
                      <path
                        strokeWidth="3.429"
                        d="M21 19.61v8.796a.857.857 0 0 0 1.33.715l6.597-4.36a.857.857 0 0 0 .006-1.427l-6.598-4.436a.857.857 0 0 0-1.335.711Z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div className="about-us-thq-growing-company-section-elm">
        <div className="about-us-container4">
          <img
            alt="image"
            src="https://raceconsulting24.com/melissaprofile-1200w.jpg"
            className="about-us-image2"
          />
          <div className="about-us-container5">
            <h3 className="about-us-text12">
              <span className="about-us-text13">
                Certified Assessment Practitioner for AchieveWorks® (Human
                eSources)
              </span>
              <span className="about-us-text14">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br className="about-us-text15 Text2XL"></br>
            </h3>
            <img
              alt="image"
              src="https://raceconsulting24.com/humanesourcecert.jpg"
              className="about-us-image3"
            />
          </div>
          <div className="about-us-container6">
            <h3 className="about-us-text16">
              <span className="about-us-text17">Member of</span>
              <br className="Text2XL"></br>
            </h3>
            <a
              href="https://www.naccap.org/about-us"
              target="_blank"
              rel="noreferrer noopener"
              className="about-us-link7"
            >
              <img
                alt="image"
                src="https://raceconsulting24.com/NACCAP Logo New Members.png"
                className="about-us-image4"
              />
            </a>
          </div>
          <div className="about-us-container9">
            <h3 className="about-us-text22">
              <span className="about-us-text23">Webinar and Blog Contributor</span>
              <br className="Text2XL"></br>
              <span className="about-us-text23">Workshop Host</span>
              <br className="Text2XL"></br>
            </h3>
            <a
              href="https://www.young-scholars.org/"
              target="_blank"
              rel="noreferrer noopener"
              className="about-us-link11"
            >
              <img
                alt="image"
                src="https://raceconsulting24.com/YoungScholarsLogo.png"
                className="about-us-image5"
              />
            </a>
          </div>
        </div>
        <div className="about-us-container7">
          <h3 className="about-us-text19 Text2XL">Melissa Decker</h3>
          <div className="about-us-container8">
            <svg viewBox="0 0 1024 1024" className="about-us-icon29">
              <path d="M810.667 213.333h-597.333l64-85.333h469.333zM929.877 230.059l-127.744-170.325c-8.363-11.136-21.077-17.024-34.133-17.067h-512c-13.909 0-26.283 6.656-34.133 17.067l-127.744 170.325c-1.835 2.389-3.456 5.035-4.736 7.808-2.773 5.803-4.096 12.032-4.053 18.133v597.333c0 35.328 14.379 67.413 37.504 90.496s55.168 37.504 90.496 37.504h597.333c35.328 0 67.413-14.379 90.496-37.504s37.504-55.168 37.504-90.496v-597.333c0-9.344-3.029-18.005-8.064-24.96-0.171-0.213-0.299-0.427-0.469-0.64zM170.667 298.667h682.667v554.667c0 11.776-4.736 22.4-12.501 30.165s-18.389 12.501-30.165 12.501h-597.333c-11.776 0-22.4-4.736-30.165-12.501s-12.501-18.389-12.501-30.165zM640 426.667c0 35.371-14.293 67.285-37.504 90.496s-55.125 37.504-90.496 37.504-67.285-14.293-90.496-37.504-37.504-55.125-37.504-90.496c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667c0 58.88 23.936 112.299 62.464 150.869s91.989 62.464 150.869 62.464 112.299-23.936 150.869-62.464 62.464-91.989 62.464-150.869c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667z"></path>
            </svg>
            <span className="about-us-text20 TextSM">
              Chief Independent Educational Consultant
            </span>
          </div>
          <span className="about-us-text21">
            <span>
              Driven by over two decades of teaching, advising, and
              administrative leadership, Melissa Decker empowers high school
              families navigating the complex journey from freshman year through
              college admissions. With firsthand experience supporting her own
              children at the University of Georgia and a deep understanding of
              the latest admissions trends, Melissa serves as a trusted guide
              and advocate. She combines a research-informed approach with a
              personal touch-attending college tours, webinars, and counseling
              events to ensure every family receives relevant, compassionate,
              and strategic support tailored to their goals. Her mission: to
              bring clarity, confidence, and calm to one of the most pivotal
              chapters in a student’s life.
            </span>
            <br></br>
            <br></br>
            <span>
              With 20+ years in education and a passion to help high school
              families, Melissa Decker uses her teaching background, along with
              her administrative and academic advising experience, to relieve
              families that are overwhelmed with all stages of high school and
              college admissions.
            </span>
            <br></br>
            <br></br>
            <span>
              In addition to helping high school families, Melissa is a Blog
              Author and Webinar Guest for the Young Scholars National Honor
              Society. She currently writes monthly blogs and creates webinars
              on topics that prepare middle schoolers for high school. Watch her
              webinar and read her blogs HERE:
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
          </span>
          <div className="about-us-other-channel-icon-parent">
            <a
              href="https://www.young-scholars.org/resources/blog/authors/melissa-decker/"
              target="_blank"
              rel="noreferrer noopener"
              className="about-us-link8"
            >
              <img
                src="https://raceconsulting24.com/Blog Symbol.png"
                alt="Blog"
                className="about-us-other-channel-icon"
              />
            </a>
            <a
              href="https://www.youtube.com/@melissadecker-n6k"
              target="_blank"
              rel="noreferrer noopener"
              className="about-us-link9"
            >
              <img
                src="https://raceconsulting24.com/Webinar Symbol.png"
                alt="Webinar"
                className="about-us-other-channel-icon"
              />
            </a>
            <a
              href="https://www.buzzsprout.com/2233911/episodes/19086348"
              target="_blank"
              rel="noreferrer noopener"
              className="about-us-link10"
            >
              <img
                src="https://raceconsulting24.com/Podcast Symbol.png"
                alt="Podcast"
                className="about-us-other-channel-icon"
              />
            </a>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AboutUs
